import React from 'react';
import styled from 'styled-components';
import { pxToRem } from 'utils/ui/units';
import { alpha } from 'utils/ui/colors';
import config from 'utils/config';
import Box from 'components/Box';
import Flex from 'components/Flex';
import useBreakpoints from 'hooks/useBreakpoints';
var NumberBox = styled(Box).withConfig({
  displayName: "ListNumberWrapper__NumberBox",
  componentId: "sc-l24wjx-0"
})(["width:", ";text-align:center;font-weight:bold;background-color:", ";border-radius:", ";border-top-right-radius:0;border-bottom-right-radius:0;"], pxToRem(64), function (p) {
  return alpha(p.theme.shade, p.theme.shadeStrength);
}, function (p) {
  return pxToRem(p.theme.globals.borderRadius.large);
});

// Note: this component is used for the old display of rank
// Can most likely be removed when the playlistSections is fully implemented
var ListNumberWrapper = function ListNumberWrapper(_ref) {
  var number = _ref.number,
    hasPlaylistNumbering = _ref.hasPlaylistNumbering,
    children = _ref.children;
  var _useBreakpoints = useBreakpoints(),
    xxs = _useBreakpoints.xxs;
  if (!hasPlaylistNumbering || config.playlistSections || number === undefined || !xxs) {
    return children;
  }
  return /*#__PURE__*/React.createElement(Flex, {
    align: "top"
  }, /*#__PURE__*/React.createElement(NumberBox, {
    py: "s",
    pr: "s",
    mr: "-s"
  }, number), /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true
  }, children));
};
export default ListNumberWrapper;